import axios from "axios";

export const fetchInvoiceList = async () => {
  const response = await axios.get("/Invoice/list");
  return response;
};
